import React from "react";
import { useSelector } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";

//public protection
function ProtectedRouter() {
    const { userInfo } = useSelector((state) => state.userLogin);

    return userInfo?.stsTokenManager?.accessToken ? (
        <Outlet />
    ) : (
        <Navigate to="/login" />
    );
}


export { ProtectedRouter };
